import React, { useState } from "react";
import { Tabs, Button, message } from "antd";
import Current from "./components/Current";
import Monthly from "./components/Monthly";
const Individual = () => {
  const [activeKey, setActiveKey] = useState("1");
  const [panes, setPanes] = useState([
    { title: "当期个税", key: "1", children: <Current /> },
    { title: "月度个税", key: "2", children: <Monthly /> },
  ]);

  const onChange = (newActiveKey) => {
    setActiveKey(newActiveKey);
  };

  return (
    <div>
      <Tabs
        onChange={onChange}
        activeKey={activeKey}
        hideAdd={false}
        style={{ backgroundColor: "#fff", padding: "20px" }}
      >
        {panes.map((pane) => (
          <Tabs.TabPane tab={pane.title} key={pane.key}>
            {pane.children}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default Individual;
